import { Color } from '../../primitives'

export const BrandColors = {
	Purple: new Color('#592B86', { darker: '#3B156A', onColor: 'white', lighter: '#F9F2FF' }),
	Green: new Color('#14E075', { darker: '#04C669', onColor: 'white', lighter: '#D6FFED' }),
	Orange: new Color('#FF7200', { darker: '#D55F00', onColor: 'white', lighter: '#FFF1E5' }),
	Text: new Color('#323232', { darker: '#000000', onColor: 'white', lighter: '#F4F4F4' })
}
